<template>
  <div class="form-studio" dir="rtl">
    <form @submit.prevent="onSubmit">
      <div class="form-studio-top">
        <router-link :to="{ name: 'Form' }" class="form-studio-back">فرم‌ها</router-link>
        <form-group class="form-studio-name" :validations="$v.form.name">
          <div slot-scope="{ errors }">
            <input v-model="form.name" type="text" class="form-studio-name-input" placeholder="نام فرم">
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
        <languageBox compact v-model="form.language_id" :validation="$v.form.language_id"/>
        <button type="submit" class="form-studio-save">ثبت</button>
      </div>

      <form-group :validations="$v.form.form_questions">
        <div slot-scope="{ errors }">
          <create-form-json :form="form"/>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </form>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import languageBox from "../Language/LanguageBox.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import CreateFormJson from "./CreateFormJson/CreateFormJson.vue";

export default {
  name: "BaseForm",
  components: {CreateFormJson, languageBox, FormErrorsManager, FormGroup},
  data() {
    return {
      form: {
        name: '',
        language_id: null,
        form_questions: '',
      }
    }
  },
  validations: {
    form: {
      name: {required},
      language_id: {required},
      form_questions: {required},
    },
  },
  computed: {
    updateMode() {
      return this.$route.params.id != undefined
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    async createForm() {
      let req = await this.$store.dispatch('Form/createForm', this.form)
      let itemId = req.data.data.id;
      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
      await this.$router.push({name: "FormUpdate", params: {id: itemId}})
    },
    async loadForm() {
      let form = {
        form_id: this.$route.params.id
      }
      let req = await this.$store.dispatch('Form/getFormDashboard', form)
      let itemData = req.data.data;
      this.form = itemData
      this.form.form_questions = JSON.parse(this.form.form_questions)
      this.form.language_id = itemData.language_id
    },
    async updateForm() {
      let req = await this.$store.dispatch('Form/updateForm', this.form)
      let itemId = req.data.data.id;
      toast('عملیات با موفقیت انجام شد', 'عملیات با موفقیت انجام شد')
    },
    onSubmit() {

      if (!this.invalid()) {
        return false
      }

      if (this.updateMode) {
        this.updateForm()
      } else {
        this.createForm()
      }

    }
  },
  mounted() {
    if (this.updateMode) {
      this.loadForm()
    }
  }
}
</script>

<style scoped>
.form-studio {
  width: 100%;
  max-width: 100%;
}

.form-studio-top {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #ece7e4;
  border-radius: 12px;
  padding: 8px 10px;
  margin-bottom: 10px;
}

.form-studio-back {
  color: #6b7280;
  font-size: 13px;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f3f4f6;
}

.form-studio-name {
  flex: 1 1 220px;
  margin: 0;
}

.form-studio-name-input {
  width: 100%;
  border: 0;
  background: transparent;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  color: #111827;
}

.form-studio-save {
  border: 0;
  background: #0f766e;
  color: #fff;
  border-radius: 999px;
  padding: 6px 18px;
  font-size: 13px;
}
</style>
